// extracted by mini-css-extract-plugin
export default {"wrapper":"FrequencyPanel_wrapper__CvUaG","content":"FrequencyPanel_content__ZrH5L"};